import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'
import _ from 'lodash'

// ------------------------------------
// Constants
// ------------------------------------
export const ASSISTANCE_LIST = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'ASSISTANCE_LIST')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: 'cgs/marketing/activity/virus/list',
        method: 'POST',
        requestAction: ASSISTANCE_LIST.INIT_REQUEST,
        successAction: ASSISTANCE_LIST.INIT_SUCCESS,
        success: function(result) {
          const { activityList = [] } = result
          const activityInfo = _.find(activityList, ['signFlag', true])
          console.log(activityInfo)
          if (activityInfo) {
            return dispatch(replace(`/assistance/detail/${activityInfo.activityCode}`))
          }
          dispatch({
            type: ASSISTANCE_LIST.INIT_SUCCESS,
            payload: {
              showPage: true
            }
          })
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ASSISTANCE_LIST.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [ASSISTANCE_LIST.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'assistanceList',
    reducerMap: {
      assistanceListState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
